import React, { memo, useRef, useCallback } from 'react'
import Form, { FormConsumer } from '@active/react-ui/Form'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormField from '@active/react-ui/FormField'
import Modal from '@active/react-ui/Modal'
import ModalBody from '@active/react-ui/ModalBody'
import ModalFooter from '@active/react-ui/ModalFooter'
import Grid from '@active/react-ui/Grid'
import GridItem from '@active/react-ui/GridItem'
import RadioGroup from '@active/react-ui/RadioGroup'
import Radio from '@active/react-ui/Radio'
import Button from '@active/react-ui/Button'
import { func, string } from 'prop-types'
import { Locale, withI18n } from '@active/react-utils/i18n'
import { maskSenderEmail, maskSenderPhone } from '../../../../shared/utils/commonUtils'
import './MFAStepOne.scss'

function MFAStepOne({
  emailAddress,
  phoneNumber,
  defaultWay,
  handleClose,
  handleReject,
  handleConfirm,
  i18n,
  ...rest
},
) {
  const okText = phoneNumber ? 'passport.common.btn.sendCode' : 'passport.common.btn.continue'
  const cancelText = 'passport.common.btn.cancel'
  const title = i18n('passport.verification.modal.title')
  const stepWayLabel = 'passport.verification.modal.stepOne.label.withColon'
  const radioLabelOfEmail = 'passport.common.label.emailAddress.withColon'
  const radioLabelOfPhone = 'passport.common.label.phoneNumber.withColon'
  const radioLabelOfVerifyPhone = 'passport.verification.modal.phone.verify'
  const formRef = useRef()

  const handleSubmit = useCallback(() => {
    handleConfirm(formRef.current.values)
  }, [handleConfirm, formRef])

  return (
    <Modal
      title={title}
      onClose={handleClose}
      size="md"
      shown
      {...rest}
      className="mfa-step-one"
    >
      <ModalBody className="modal-body mfa-step-one-content">
        <Form
          initialValues={{
            defaultWay,
          }}
        >
          <Grid fluid rowGap={0} colGap={0}>
            <GridItem span={12} spanSm={8}>
              <FormGroup name="defaultWay" withoutLayout>
                <FormLabel verticalStart><Locale id={stepWayLabel} /></FormLabel>
                <FormField as={RadioGroup}>
                  <Radio value="EMAIL">
                    <span>
                      <Locale id={radioLabelOfEmail} />
                    </span>
                    <span className="contact-info">
                      {maskSenderEmail(emailAddress)}
                    </span>
                  </Radio>
                  <Radio value="SMS">
                    {
                      phoneNumber ? (
                        <>
                          <span>
                            <Locale id={radioLabelOfPhone} />
                          </span>
                          <span className="contact-info">
                            {maskSenderPhone(phoneNumber)}
                          </span>
                        </>
                      ) : (
                        <span>
                          <Locale id={radioLabelOfVerifyPhone} />
                        </span>
                      )
                    }
                  </Radio>
                </FormField>
              </FormGroup>
            </GridItem>
          </Grid>
          <FormConsumer>
            {
              ({
                form,
              }) => {
                formRef.current = form
              }
            }
          </FormConsumer>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          type="strong"
          onClick={handleSubmit}
        >
          <Locale id={okText} />
        </Button>
        <Button
          type="secondary"
          onClick={handleReject}
        >
          <Locale id={cancelText} />
        </Button>
      </ModalFooter>
    </Modal>

  )
}

MFAStepOne.propTypes = {
  emailAddress: string.isRequired,
  handleClose: func.isRequired,
  handleReject: func.isRequired,
  handleConfirm: func.isRequired,
  i18n: func.isRequired,
  phoneNumber: string,
  defaultWay: string,
}

MFAStepOne.defaultProps = {
  phoneNumber: '',
  defaultWay: 'EMAIL',
}
export default memo(withI18n(MFAStepOne))
